import moment from 'moment';
import type { MouseEvent } from 'react';

import { Action } from '../../../typings/permissions';
import { window } from '../../globals';
import { userHasPermissionForProject } from '../../helpers/permissions';
import { isDependencyCacheValid } from '../../helpers/revisions';
import Icon, { icons } from '../generic/Icon';
import Tooltip from '../generic/Tooltip';

import type { ProjectDashboardProject, ProjectDashboardRevision } from './projectDashboardTypes';

type OwnProps = {
  project: ProjectDashboardProject;
  revision: ProjectDashboardRevision;
  onScanIssues: (event: MouseEvent<HTMLElement>) => void;
};

const ButtonRescanProject = ({
  project,
  revision,
  onScanIssues,
}: OwnProps) => {
  const lastScan = revision.data?.meta?.[0]?.last_scan ?? null;

  const noPermissionToScan =
    !window.user ||
    project.data?.organizationId !== window.user.organizationId ||
    !userHasPermissionForProject(Action.Edit, project.data.locator);
  const canScanRevision = isDependencyCacheValid(revision.data);
  // users with restricted roles cannot perform a policy scan
  if (noPermissionToScan || !canScanRevision) {
    const tooltipMessage = noPermissionToScan ? 'Requires a project maintainer to trigger policy scan' : 'FOSSA is still determining the dependencies for this revision';
    return (
      <Tooltip
        placement="top"
        tooltip={<span><Icon icon={icons.lock} /> {tooltipMessage}</span>}
      >
        <a className="btn-scan disabled">
          <Icon icon={icons.reload} /> Run policy scan
        </a>
      </Tooltip>
    );
  }
  return (
    <Tooltip
      placement="top"
      tooltip={<span><b>Last policy scan:</b> {lastScan ? moment(lastScan).fromNow() : 'Unknown'}</span>}
    >
      <a
        className="clickable btn-scan"
        onClick={onScanIssues}
      >
        <Icon icon={icons.reload} /> Run policy scan
      </a>
    </Tooltip>
  );
};

export default ButtonRescanProject;
